import { t } from 'i18next';
import { LeafBadge, RoundBadge, ThumbnailPhotoCard } from '@peacecover/component';
import { MatchingFill } from '@peacecover/icon';

interface CardTwinProps {
  myPhotoCardImgUrl: string;
  myPhotoCardTitle: string;
  myPhotoCardSubTitle: string;
  isDone: boolean;
  otherPhotoCardImgUrl: string;
  otherPhotoCardTitle: string;
  otherPhotoCardSubTitle: string;
  className?: string;
  imgClassName?: string;
}

const CardTwin = ({
  myPhotoCardImgUrl,
  myPhotoCardTitle,
  myPhotoCardSubTitle,
  isDone,
  otherPhotoCardImgUrl,
  otherPhotoCardTitle,
  otherPhotoCardSubTitle,
  className = '',
  imgClassName = ''
}: CardTwinProps) => {
  return (
    <div
      className={`flex justify-between items-center rounded-[12px] border border-separator1 gap-[4px] dark:bg-separator2 ${className}`}
    >
      <div className="flex items-center gap-[8px]">
        <div className="relative">
          <ThumbnailPhotoCard
            imageUrl={myPhotoCardImgUrl}
            className={`w-[29px] h-[46px] rounded-[4px] ${imgClassName}`}
          />
          <LeafBadge
            position="left"
            size="small"
            text={t('TradingPhotoCardReviewsPage.me') as string}
            className="absolute left-0 bottom-0 text-pure-white dark:text-pure-black bg-pure-black dark:bg-pure-white"
          />
        </div>
        <div className="flex flex-col items-start gap-[5px] leading-none">
          <p className="text-[12px] font-bold text-on-label w-[73px] truncate">
            {myPhotoCardTitle}
          </p>
          <p className="text-[11px] text-text-sub-lv1 w-[73px] truncate">{myPhotoCardSubTitle}</p>
        </div>
      </div>
      <div className="flex flex-col items-center gap-[5px]">
        <MatchingFill size={16} className="text-text-sub-lv1" />
        <RoundBadge size="small" className="h-[15px] px-[5px] py-[2px] text-[9px] rounded-[20px]">
          {isDone
            ? t('TradingPhotoCardReviewsPage.status.done')
            : t('TradingPhotoCardReviewsPage.status.isExchange')}
        </RoundBadge>
      </div>
      <div className="flex items-center gap-[8px]">
        <div className="flex flex-col items-end gap-[5px] leading-none">
          <p className="text-[12px] font-bold text-on-label w-[73px] truncate">
            {otherPhotoCardTitle}
          </p>
          <p className="text-[11px] text-text-sub-lv1 w-[73px] truncate">
            {otherPhotoCardSubTitle}
          </p>
        </div>
        <div className="relative">
          <ThumbnailPhotoCard
            imageUrl={otherPhotoCardImgUrl}
            className={`w-[29px] h-[46px] rounded-[4px] ${imgClassName}`}
          />
          <LeafBadge
            position="right"
            size="small"
            text={t('TradingPhotoCardReviewsPage.other') as string}
            className="absolute right-0 bottom-0 text-pure-white dark:text-pure-black bg-pure-black dark:bg-pure-white"
          />
        </div>
      </div>
    </div>
  );
};

export default CardTwin;
